module.exports = __webpack_public_path__ + "static/img/pic_coop03@2x.763dfda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productServices/brandOperation/serviceContent/pic_coop03@2x.png
// module id = dkdF
// module chunks = 0